import { Accordion, AccordionHeader, AccordionItem, AccordionPanel } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { AwardGroup, AwardGroupRef } from '../../../models';
import { FlexBox } from '../../shared-components/flex-box';
import './StaffAwardGroupList.scss';

interface Props {
  awardGroups: AwardGroup[];
  onAwardSelected(award: AwardGroupRef): void;
  onGroupSelected(awardGroup: AwardGroup): void;
  isAwardUpdated(award: AwardGroupRef): boolean;
  isGroupUpdated(group: AwardGroup): boolean;
}

const StaffAwardGroupList: React.FC<Props> = props => {
  const { awardGroups, onAwardSelected, onGroupSelected, isAwardUpdated, isGroupUpdated } = props;

  const isAwardInGroupUpdated = (awardGroup: AwardGroup): boolean => {
    return awardGroup.awards.some(award => isAwardUpdated(award));
  }

  return (
    <FlexBox
      direction='column'
      className='staff-award-group-list'
    >
      <Accordion
        collapsible
        className='staff-award-group-list__accordion'
      >
        {
          awardGroups.map((awardGroup: AwardGroup) => {
            const key = awardGroup.awardGroupId.toString();
            const showGroupDot = isGroupUpdated(awardGroup) || isAwardInGroupUpdated(awardGroup);

            return (
              <AccordionItem
                key={`award-group-${key}`}
                value={`award-group-${key}`}
              >
                <AccordionHeader
                  onClick={() => onGroupSelected(awardGroup)}
                >
                  {showGroupDot && <span className='dot' />}
                  {awardGroup.title}
                </AccordionHeader>
                <AccordionPanel>
                  {
                    awardGroup.awards.map(award => (
                      <FlexBox
                        key={award.awardId}
                        className='list-wrapper'
                        aligns='center'
                      >
                        <button
                          onClick={() => onAwardSelected(award)}
                          key={award.awardId.toString()}
                          className='panel__item'
                        >
                          {isAwardUpdated(award) && <span className='dot' />}
                          {award.title}
                        </button>
                      </FlexBox>
                    ))
                  }
                </AccordionPanel>
              </AccordionItem>
            );
          })
        }
      </Accordion>
    </FlexBox>
  );
}

export default observer(StaffAwardGroupList);
